// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1z9bv","error":"Textarea_error__1IQA-","readonly":"Textarea_readonly__1Wc1C","disabled":"Textarea_disabled__3EZE8"};